/** 길드 결제 입력/영수증 복구. 은화·명예를 화면에서 확정하거나 낙관 차감하지 않는다. */
import { S, $ } from '../core/state.js';
import { send } from '../core/net.js';

const STORAGE = 'unige.guild.receipt.v1';
let replyTimer = 0;
export const guildInteger = (value) => /^\d+$/.test(String(value ?? '')) ? BigInt(value) : 0n;
export const guildMoneyText = (value) => guildInteger(value).toLocaleString('ko-KR');

function savedRequest(pending) {
  try {
    if (pending) sessionStorage.setItem(STORAGE, JSON.stringify(pending));
    else sessionStorage.removeItem(STORAGE);
  } catch { /* 저장을 금지한 브라우저에서도 현재 탭의 미확정 영수증은 메모리에 남는다. */ }
}

/** 서버 길드 조회 뒤 호출. 새로고침해도 결과 확인 전 별도 결제를 시작하지 않는다. */
export function restoreGuildMoney() {
  if (S.guildMoneyPending) return;
  try {
    const p = JSON.parse(sessionStorage.getItem(STORAGE) || 'null');
    if (p?.charId !== S.charId || !p?.request?.guildId) return;
    if (!/^[a-f0-9-]{36}$/i.test(p.request.receipt)
        || !['guildDonate', 'guildAllocate', 'guildEstateBuy'].includes(p.request.t)) return;
    S.guildMoneyPending = { ...p, status: 'uncertain' };
  } catch { /* 손상된 초안은 명령으로 보내지 않는다. */ }
}

export function guildMoneyAmount(value) {
  S.guildMoneyConfirmation = null;
  S.guildMoneyDraft.amount = String(value ?? '').replaceAll(',', '').slice(0, 100);
  const amount = guildInteger(S.guildMoneyDraft.amount), e = S.guild?.economy;
  const valid = amount > 0n && amount % 100n === 0n;
  const allocating = S.guildMoneyDraft.mode === 'allocate' && S.guild?.me?.role === 'master';
  const out = $('#guild-money-honor');
  if (out) out.textContent = valid ? guildMoneyText(allocating ? 0n : amount / 100n) : '—';
  const button = $('#guild-money-submit');
  if (button) button.disabled = !!(S.guildMoneyPending || S.guildShopPending) || !valid || !(allocating ? e?.canAllocate : e?.canDonate);
  const hint = $('#guild-money-validation');
  if (hint) hint.textContent = valid ? (allocating ? '길드 금고에서 선택한 건물에 투자한다. 명예는 추가되지 않는다.' : '지갑에서 먼저 내고 부족분은 창고에서 내며, 전액 길드 금고에 들어간다.') : '100 은화 단위로 입력해 달라.';
}

export function guildMoneyChoose(mode, kind, building, redraw) {
  if (S.guildMoneyPending) return;
  S.guildMoneyConfirmation = null;
  const e = S.guild?.economy;
  const allocating = mode === 'allocate';
  if (allocating && (S.guild?.me?.role !== 'master' || !e?.canAllocate)) return;
  if (allocating && (!building || !(e?.buildings || []).some((b) => b.id === building))) return;
  Object.assign(S.guildMoneyDraft, { mode: allocating ? 'allocate' : 'donate', kind: allocating ? 'building' : 'treasury',
    building: building || S.guildMoneyDraft.building });
  S.guildMoneyNotice = ''; redraw(true);
}

export function guildMoneyAdd(value, redraw) {
  if (S.guildMoneyPending) return;
  S.guildMoneyConfirmation = null;
  S.guildMoneyDraft.amount = String(guildInteger(S.guildMoneyDraft.amount) + guildInteger(value));
  redraw(true);
}

export function guildMoneyMax(redraw) {
  if (S.guildMoneyPending) return;
  S.guildMoneyConfirmation = null;
  const e = S.guild?.economy, allocating = S.guildMoneyDraft.mode === 'allocate' && S.guild?.me?.role === 'master';
  S.guildMoneyDraft.amount = String(guildInteger(allocating ? e?.treasury : e?.usableSilver) / 100n * 100n);
  redraw(true);
}

function transmit(redraw) {
  const p = S.guildMoneyPending;
  if (!p || p.charId !== S.charId) return;
  if (!S.connected || S.ws?.readyState !== 1) {
    p.status = 'uncertain'; S.guildMoneyNotice = '연결을 확인한 뒤 기부·투자 결과를 다시 확인해 달라. 은화는 중복 차감되지 않는다.';
    redraw(true); return;
  }
  p.status = 'waiting'; savedRequest(p); send(p.request);
  clearTimeout(replyTimer);
  replyTimer = setTimeout(() => {
    if (S.guildMoneyPending?.request.receipt !== p.request.receipt) return;
    p.status = 'uncertain'; savedRequest(p); redraw(true);
  }, 12000);
  redraw(true);
}

export function guildMoneySubmit(redraw) {
  if (S.guildMoneyPending) return;
  if (S.guildShopPending) return;
  const e = S.guild?.economy, guild = S.guild?.me?.guild, d = S.guildMoneyDraft;
  const amount = guildInteger(d.amount), allocating = d.mode === 'allocate' && S.guild?.me?.role === 'master';
  if (!guild || !e || !(allocating ? e.canAllocate : e.canDonate) || amount <= 0n || amount % 100n) return;
  if (!S.connected || S.ws?.readyState !== 1) { S.guildMoneyNotice = '연결을 복구하는 중이다. 잠시 뒤 다시 시도해 달라.'; redraw(true); return; }
  const target = allocating ? e.buildings?.find((b) => b.id === d.building)?.name : '';
  if (allocating && !target) return;
  const question = allocating
    ? `길드 금고에서 ${target}에 ${guildMoneyText(amount)} 은화를 투자할까? 명예는 추가되지 않는다.`
    : `길드 금고에 ${guildMoneyText(amount)} 은화를 기부할까? 받을 명예: ${guildMoneyText(amount / 100n)}. 기부는 환불할 수 없다.`;
  const request = { t: allocating ? 'guildAllocate' : 'guildDonate', guildId: guild.id,
    receipt: crypto.randomUUID(), silver: String(amount), kind: allocating ? 'building' : 'treasury' };
  if (allocating) request.building = d.building;
  S.guildMoneyConfirmation = { charId: S.charId, request, question };
  redraw(true);
}

/** Uses the same persisted confirmation/receipt flow as all guild treasury payments. */
export function guildEstateBuy(estateId,redraw) {
  if(S.guildMoneyPending||S.guildShopPending)return;
  const g=S.guild,e=g?.estate,plot=e?.plots?.find(x=>x.id===estateId);
  if(!g?.me?.guild||g.me.role!=='master'||!e?.canPurchase||!plot||plot.ownerName)return;
  S.guildMoneyConfirmation={charId:S.charId,request:{t:'guildEstateBuy',receipt:crypto.randomUUID(),guildId:g.me.guild.id,estateId,silver:String(e.purchaseSilver)},
    question:`회원들이 기부한 길드 금고에서 ${guildMoneyText(e.purchaseSilver)} 은화로 ${plot.name||plot.id} 부지를 구매할까? 소유권은 세계 초기화 후에도 남는다.`};
  S.guildView='overview';
  redraw(true);
}

/** 게임 내부 확인 화면. 브라우저 모달로 렌더/연결 처리를 멈추지 않는다. */
export function guildMoneyConfirm(redraw) {
  if (S.guildMoneyPending) return;
  if (S.guildShopPending) return;
  const draft = S.guildMoneyConfirmation;
  if (!draft || draft.charId !== S.charId || draft.request.guildId !== S.guild?.me?.guild?.id) return;
  S.guildMoneyConfirmation = null;
  S.guildMoneyPending = { charId: S.charId, request: draft.request, status: 'waiting' };
  S.guildMoneyNotice = ''; transmit(redraw);
}

export function guildMoneyCancel(redraw) { S.guildMoneyConfirmation = null; redraw(true); }

export function guildMoneyRetry(redraw) { transmit(redraw); }

export function guildMoneyAck(message) {
  const p = S.guildMoneyPending;
  if (!p || p.charId !== S.charId || p.request.receipt !== message.receipt) return false;
  clearTimeout(replyTimer); replyTimer = 0;
  if (!message.ok && message.retryable) {
    p.status = 'uncertain'; savedRequest(p);
    S.guildMoneyNotice = message.error || '기부·투자 결과를 확인하지 못했다. 결과 확인을 다시 눌러 달라.';
  } else {
    S.guildMoneyPending = null; savedRequest(null);
    S.guildMoneyNotice = message.ok
      ? (message.replayed ? '이미 완료된 요청이다. 은화는 추가 차감되지 않았다.'
        : p.request.t === 'guildEstateBuy' ? '길드 영지 부지 구매가 완료되었다.'
          : p.request.t === 'guildAllocate' ? '길드 금고 자금의 건물 투자가 완료되었다.' : '길드 금고 기부가 완료되었다.')
      : (message.error || '기부·투자를 처리하지 못했다. 잔액과 길드 상태를 확인해 달라.');
  }
  return true;
}
